import { Capacity } from '@/features/execute-calculation-set/overmind/calculation/domain/Capacity';

import { AttentionStatus } from '../../../../../AttentionStatus';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class AvailableCapacityEvaluation {
  private readonly ruleName = 'Mv_PowerTransformer_AvailableCapacity';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(
    availableCapacity: number | undefined | null
  ): EvaluationResultType<Capacity> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      availableCapacity
    );
    const value = Capacity.from(availableCapacity).toKiloVoltAmpere(); // TODO: remove unit change from evaluation
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
